import styled from "styled-components";
import { lineClampStyle, type LineClampStyleType } from "../../../../styles/v2/toyota/utilities/LineClamp";
import { theme } from "../../../../styles/v2/toyota/theme/toyotaTheme";

export const LineClamp = styled.div<LineClampStyleType>`
    ${lineClampStyle};
    padding-block: ${theme.space[3] / 2}px;
    line-height: 2.4rem;
`;
